import { format } from "date-fns";
import { translateStatusValues } from "./checkObjectProperties";
import { formatCurrency, formatDocument } from "./formatters";

export function ConvertObjectTranslatedToArray (ObjectToBeTransformed, tableName) {
  let array = [];

  console.log(ObjectToBeTransformed)

  Object.keys(ObjectToBeTransformed).forEach((key) => {

    if (ObjectToBeTransformed[key] === "") {
      return;
    }



    switch (key) {
      //FILTRO SALES
      case "endToEndId":
        array.push({
          "Cód. de rastreio": ObjectToBeTransformed[key],
          [key]: "",
        });
        break;
      case "trace_id":
        array.push({
          "Cód. de rastreio": ObjectToBeTransformed[key],
          [key]: "",
        });
        break;
      case "startAmount":
        array.push({
          "Valor min.": formatCurrency(ObjectToBeTransformed[key]),
          [key]: "",
        });
        break;
      case "endAmount":
        array.push({
          "Valor máx.": formatCurrency(ObjectToBeTransformed[key]),
          [key]: "",
        });
        break;
      case "startDate":
        array.push({
          "Data inicial": format(
            new Date(
              ObjectToBeTransformed[key].replace(/-/g, "/").replace(/T.+/, "")
            ),
            "dd/MM/yyyy"
          ),
          [key]: "",
        });
        break;
      case "endDate":
        array.push({
          "Data final": format(
            new Date(
              ObjectToBeTransformed[key].replace(/-/g, "/").replace(/T.+/, "")
            ),
            "dd/MM/yyyy"
          ),
          [key]: "",
        });
        break;
      case "start_date":
        array.push({
          "Data inicial": format(
            new Date(
              ObjectToBeTransformed[key].replace(/-/g, "/").replace(/T.+/, "")
            ),
            "dd/MM/yyyy"
          ),
          [key]: "",
        });
        break;
      case "end_date":
        array.push({
          "Data final": format(
            new Date(
              ObjectToBeTransformed[key].replace(/-/g, "/").replace(/T.+/, "")
            ),
            "dd/MM/yyyy"
          ),
          [key]: "",
        });
        break;
      case "id":
        array.push({
          "Identificador PIX": ObjectToBeTransformed[key],
          [key]: "",
        });
        break;
      case "id":
        array.push({
          "Identificador PIX": ObjectToBeTransformed[key],
          [key]: "",
        });
        break;

      case "externalId":
        array.push({ "External ID": ObjectToBeTransformed[key], [key]: "" });
        break;
      case "external_id":
        array.push({ "External ID": ObjectToBeTransformed[key], [key]: "" });
        break;
      case "name":
        array.push({ Pagador: ObjectToBeTransformed[key], [key]: "" });
        break;
      case "document":
        array.push({ Documento: ObjectToBeTransformed[key], [key]: "" });
        break;
      case "status":
        array.push({
          Status: translateStatusValues(ObjectToBeTransformed[key], tableName),
          [key]: "",
        });
        break;

      //Filtro de Boletos
      case "due_date_start":
        array.push({
          "Data inicial de vencimento": format(
            new Date(
              ObjectToBeTransformed[key].replace(/-/g, "/").replace(/T.+/, "")
            ),
            "dd/MM/yyyy"
          ),
          [key]: "",
        });
        break;
      case "due_date_end":
        array.push({
          "Data final de vencimento": format(
            new Date(
              ObjectToBeTransformed[key].replace(/-/g, "/").replace(/T.+/, "")
            ),
            "dd/MM/yyyy"
          ),
          [key]: "",
        });
        break;
      case "type":
        array.push({
          Status: translateStatusValues(ObjectToBeTransformed[key]),
          [key]: "",
        });
        break;
      case "start_amount":
        array.push({
          "Valor min.": formatCurrency(ObjectToBeTransformed[key]),
          [key]: "",
        });
        break;
      case "end_amount":
        array.push({
          "Valor máx.": formatCurrency(ObjectToBeTransformed[key]),
          [key]: "",
        });
        break;
      case "productId":
        array.push({
          "Tipo de PIX":
            ObjectToBeTransformed[key] === 149
              ? "149: PIX Recebimento"
              : ObjectToBeTransformed[key] === 150
              ? "150: PIX Pagamento"
              : ObjectToBeTransformed[key],
          [key]: "",
        });
        break;
      case "sub_account_id":
        array.push({
          "Ponto de venda": ObjectToBeTransformed[key],
          [key]: "",
        });
        break;
      case "accessKey":
        array.push({ "Chave de Acesso": ObjectToBeTransformed[key], [key]: "" });
        break;
      case "protocol":
        array.push({ "Protocolo": ObjectToBeTransformed[key], [key]: "" });
        break;
      case "document":
        array.push({
          "Document": formatDocument(
            ObjectToBeTransformed[key],
            ObjectToBeTransformed[key] && ObjectToBeTransformed[key].length > 11
              ? "CNPJ_COMPACT"
              : "CPF"
          ), [key]: ""
        });
        break;
      case "manifested":
        array.push({
          Manifestada: ObjectToBeTransformed[key] ? "Sim" : "Não",
          [key]: "",
        });
        break;
      case "recipient":
        array.push({ "Destinatário": ObjectToBeTransformed[key], [key]: "" });
        break;
      case "isAnticipation":
        array.push({
          'Boleto Antecipado': ObjectToBeTransformed[key] ? "Sim" : "Não",
          [key]: "",
        });
        break;
      default:
        "";
    }
  });
  return array;
}
